import Model from '@/models/Model.js';

export default class MeetingUser extends Model {
    static entity = 'meeting_users';

    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            provider: this.attr(null),
            provider_user_id: this.attr(null),
            provider_email: this.attr(null),

            ...super.fields(),

            user: this.belongsTo('users', 'user_id'),
        };
    }
}
